import { Icon, Surface, Txt } from '@vst/beam';
import styles from './checkoutCartFiberDiscount.module.scss';
import { Offer } from '@vst/beam-icons/icons';
import { FiberDiscounts } from '@buy-viasat/types/build/bv';

type CheckoutCartFiberDiscountProps = {
  fiberDiscount: FiberDiscounts | undefined | null;
};

export const CheckoutCartFiberDiscount = ({ fiberDiscount }: CheckoutCartFiberDiscountProps) => {
  if (!fiberDiscount) {
    return null;
  }

  return (
    <Surface variant={'secondary'} data-testid={'fiberDiscount'} className={styles['fiberDiscountContainer']} py="8px">
      <Txt color="success" variant="bodySmallBold" className={styles['offerAndTag']}>
        {fiberDiscount.name}
        <Icon icon={Offer} size="16px" color="green_700" ml="8px" />
      </Txt>
    </Surface>
  );
};
